mainApp.directive('accountDetailItem', function() {
    return {
        templateUrl: '/public/directives/accountDetailItem.html',
        scope: {
            item: "=?",
            fromDate: "=",
            toDate: "="
        },
        link: function ($scope, elem) {
            $scope.el = elem;
        },
        controller: ["$scope","DateTimeService","AccountItemService", "$timeout", function($scope,DateTimeService, AccountItemService, $timeout) {

            $scope.localFromDate = $scope.fromDate;
            $scope.localToDate = $scope.toDate;

            $scope.date = {
                startDate: new Date($scope.localFromDate),
                endDate: new Date($scope.localToDate),
            };

            $scope.opts = {
                startDate: $scope.date.startDate,
                endDate: $scope.date.endDate,
                opens: 'left',
                showDropdowns: true
            };


            if(isSystemLogin){
                $scope.isSystemLogin = true;
            }

            $scope.open = function () {
                $($scope.el).find('.date-picker').click();
            };

            if(!$scope.currentTimeRange){
                $scope.currentTimeRange = DateTimeService.DEFAULT_TIME_FRAME_TYPE+DateTimeService.DEFAULT_TIME_FRAME_SIZE
            }

            $scope.setTimeRange = function(timeFrameType,timeFrameSize,fromDate,toDate){
                if (timeFrameType === 'Custom') {
                    $scope.open();
                    return;
                }
                $scope.updateItem(timeFrameType,timeFrameSize,fromDate,toDate);
            };

            $scope.updateItem = function (timeFrameType,timeFrameSize,fromDate,toDate) {
                $scope.item.loadingTimeData = true;
                $scope.currentTimeRange = timeFrameType+timeFrameSize;
                var newTimeFrame = DateTimeService.calculateTimeFrame(timeFrameType, timeFrameSize, fromDate, toDate);
                $scope.localToDate = newTimeFrame.toDate;
                $scope.localFromDate = newTimeFrame.fromDate;
                $scope.usageType = DateTimeService.calculateUsageType(timeFrameType, timeFrameSize);
                store.fetch({
                    method: 'POST',
                    path: "/accounts?accountId=" + $scope.item.id+"&showMe=true&onlyMe=true&onlyReseller=false&viewType=Detail&usageType="+$scope.usageType,
                    data: {dateField:"",fromDate:$scope.localFromDate,toDate:$scope.localToDate,from:0,limit:1,orders:[{path:"name",dir:"ACS"}],type:"Account"},
                    dataObj: 'dataConfig',
                    success: function (data) {
                        if(data && data.items) {
                            $timeout(function() {
                                $scope.item = data.items[0];
                                AccountItemService.parseItemData($scope.item);
                            }, 1);
                        }
                        $scope.item.loading = false;
                    }
                });

            };

            $scope.$watch('date', function (newDate, oldDate) {
                if (newDate && !_.isEqual(newDate, oldDate)) {
                  $scope.updateItem('Custom',-1,$scope.date.startDate.getTime(),$scope.date.endDate.getTime());
                }
            }, true);

        }]
    }
});